module.exports = __webpack_public_path__ + "static/media/default_avatar.5a021ab9.png";